/** The longest free-text project label the row accepts. */
export const MAX_LABEL_LENGTH = 60;

/**
 * Normalises typed free text for the entry's `service` label: surrounding whitespace is
 * trimmed and every run of whitespace, line breaks included, collapses to one space, so the
 * label is a single line.
 *
 * @param {unknown} text What was typed.
 * @returns {{value: string, empty: boolean, tooLong: boolean}} `value` is the normalised
 *   text; a label is usable when it is neither `empty` nor `tooLong`.
 */
export function normalizeLabel(text) {
  const value = String(text ?? '').replace(/\s+/g, ' ').trim();
  return { value, empty: value.length === 0, tooLong: value.length > MAX_LABEL_LENGTH };
}
